import axios from "axios";
import { API_GET_REVIEWS_BY_PRODUCT_DATA, API_GET_REVIEWS_DATA, API_INSERT_REVIEW_BY_PRODUCT_DATA, API_TOGGLE_REVIEW_DATA, API_UPDATE_REVIEW_DATA } from ".";

export const getReviewsList = async (func, config) => {
    return axios.get(API_GET_REVIEWS_DATA, config).then(res => func(res.data.data));
}

export const getReviewsByProductData = async (data, config) => {
    return axios.put(API_GET_REVIEWS_BY_PRODUCT_DATA, data, config).then((res) => res.data);
};

export const insertReviewByProductData = async (data, config) => {
    return axios.post(API_INSERT_REVIEW_BY_PRODUCT_DATA, data, config).then((res) => res.data);
};

export const updateReviewData = async (data, config) => {
    return axios.put(API_UPDATE_REVIEW_DATA, data, config).then((res) => res.data);
};

export const toggleReviewData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_REVIEW_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};